import React, {ReactElement} from 'react';
import AurTooltip from '../aur-tooltip/AurTooltip';

interface ProgressBarStripeDataType {
  filled: boolean;
  width: number;
  height: number;
  spaceBetween: number;
  color: string;
  unfilledColor?: string;
  toolTip?: string | ReactElement | null;
  testId?: string;
}

const BarStripe: React.FC<ProgressBarStripeDataType> = ({
  filled,
  width,
  height,
  spaceBetween,
  color,
  unfilledColor,
  toolTip,
  testId = 'bar-stripe',
}) => {
  const renderBar = () => {
    return (
      <span
        style={{
          opacity: unfilledColor ? 1 : filled ? 1 : 0.4,
          backgroundColor: unfilledColor
            ? filled
              ? color
              : unfilledColor
            : color,
          marginRight: `${spaceBetween}px`,
          width: `${width}px`,
          height: `${height}px`,
        }}
        data-testid={testId}
      />
    );
  };
  return toolTip ? (
    <AurTooltip
      title={toolTip}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      {renderBar()}
    </AurTooltip>
  ) : (
    renderBar()
  );
};

export default BarStripe;
